import { render, staticRenderFns } from "./MapArea.vue?vue&type=template&id=2be1b2f4&scoped=true&"
import script from "./MapArea.vue?vue&type=script&lang=js&"
export * from "./MapArea.vue?vue&type=script&lang=js&"
import style0 from "./MapArea.vue?vue&type=style&index=0&id=2be1b2f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be1b2f4",
  null
  
)

export default component.exports